(function (ws) {
    'use strict';

    ws.models.changeState = Backbone.Model.extend({
        urlRoot: function() {
            return globals.path.api.westcon.threePLInboudCreatNewRequestStateList + '?countryIsoCode=' + this.get('countryIsoCode');
        },

        /**
         * Get Country
         * @param {string} country
         */
        getCountry: function (country) {
            return _.findWhere(this.toJSON(), {
                isocode: country
            });
        }

    });
})(westcon);
